import React, { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
import Header from '../LandingPage/Header'
import Footer from '../Registration/Footer'

const RescheduleExam = () => {
    const [form, setForm] = useState({
        name: '',
        applicationNo: '',
        email: '',
        program: '',
        preferredDateTime: '',
        reason: '',
        originalDateTime: '',
    })

    const handleChange = (e) => {
        const { name, value } = e.target
        setForm((s) => ({ ...s, [name]: value }))
    }

    // generate options for next 21 days for predefined slots
    const timeSlots = ['09:00', '11:30', '14:00']
    const generateDateTimeOptions = (days = 21) => {
        const opts = []
        const pad = (n) => n.toString().padStart(2, '0')
        for (let d = 0; d < days; d++) {
            const date = new Date()
            date.setDate(date.getDate() + d)
            const yyyy = date.getFullYear()
            const mm = pad(date.getMonth() + 1)
            const dd = pad(date.getDate())
            timeSlots.forEach((ts) => {
                const [hh, mi] = ts.split(':')
                const value = `${yyyy}-${mm}-${dd}T${hh}:${mi}`
                const label = `${yyyy}-${mm}-${dd} ${ts}`
                opts.push({ value, label })
            })
        }
        return opts
    }
    const dateTimeOptions = generateDateTimeOptions()

    const validate = () => {
        const { name, applicationNo, email, program, preferredDateTime, reason, originalDateTime } = form
        if (!name || !applicationNo || !email || !program || !preferredDateTime || !reason || !originalDateTime) {
            toast.error('Please fill all required fields')
            return false
        }
        // simple email check
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(email)) {
            toast.error('Please enter a valid email')
            return false
        }
        return true
    }

    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [modalMessage, setModalMessage] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validate()) return

        setLoading(true)
        try {
            const payload = { ...form }
            const res = await axios.post('/reschedule-request', payload)

            toast.success(res.data.message || 'Reschedule request submitted.')
            setModalMessage('Your Reschedule Request is successfully submitted\nA confirmation mail will be sent on your official email id within next 24 hours.')
            setShowModal(true)

            setForm({
                name: '',
                applicationNo: '',
                email: '',
                program: '',
                preferredDateTime: '',
                reason: '',
                originalDateTime: '',
            })
        } catch (err) {
            const msg = err.response?.data?.message || err.message || 'An error occurred'
            toast.error(msg)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Header />

            <div className="min-h-screen bg-slate-100 py-6 px-3">
                <div className="max-w-3xl mx-auto">
                    {/* Professional Header */}
                    <div className="bg-white rounded-lg shadow-sm border-l-4 mb-4"
                        style={{ borderColor: "#e35e26" }}>
                        <div className="p-4">
                            <h2 className="text-xl font-semibold text-slate-800 text-center">
                                Exam Date Reschedule Request
                            </h2>
                            <p className="text-sm text-slate-500 mt-0.5 text-center">
                                (Submit a request to change your scheduled examination date)
                            </p>
                        </div>
                    </div>


                    {/* Compact Form */}
                    <form
                        // onSubmit={handleSubmit}
                        onSubmit={()=>{alert("Time Over for ")}}
                        className="bg-white rounded-lg shadow-sm p-4 space-y-4"
                    >
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

                            {/* Name */}
                            <div>
                                <label className="text-xs font-medium text-slate-600">
                                    Full Name *
                                </label>
                                <input
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 rounded-md border border-slate-300
            px-2.5 py-1.5 text-sm
            focus:outline-none focus:ring-1 focus:ring-[#e35e26]
            focus:border-[#e35e26]"
                                />
                            </div>

                            {/* Application No */}
                            <div>
                                <label className="text-xs font-medium text-slate-600">
                                    Application No. *
                                </label>
                                <input
                                    name="applicationNo"
                                    value={form.applicationNo}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 rounded-md border border-slate-300
            px-2.5 py-1.5 text-sm
            focus:outline-none focus:ring-1 focus:ring-[#e35e26]
            focus:border-[#e35e26]"
                                />
                            </div>

                            {/* Email */}
                            <div>
                                <label className="text-xs font-medium text-slate-600">
                                    Registered Email *
                                </label>
                                <input
                                    name="email"
                                    type="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 rounded-md border border-slate-300
            px-2.5 py-1.5 text-sm
            focus:outline-none focus:ring-1 focus:ring-[#e35e26]
            focus:border-[#e35e26]"
                                />
                            </div>

                            {/* Program */}
                            <div>
                                <label className="text-xs font-medium text-slate-600">
                                    Program *
                                </label>
                                <select
                                    name="program"
                                    value={form.program}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 rounded-md border border-slate-300
            px-2.5 py-1.5 text-sm bg-white
            focus:outline-none focus:ring-1 focus:ring-[#e35e26]
            focus:border-[#e35e26]"
                                >
                                    <option value="">Select program</option>
                                    <option value="engineering">Engineering (B.Tech / B.E)</option>
                                    <option value="mba-pgdm">MBA / PGDM</option>
                                    <option value="bba">BBA</option>
                                    <option value="bca">BCA</option>
                                    <option value="biotechnology">Bio Technology</option>
                                    <option value="b-pharmacy">B.Pharmacy</option>
                                    <option value="agriculture">Agriculture</option>
                                    <option value="aeronautical">Aeronautical / Aerospace</option>
                                    <option value="bsc-datascience">BSc Data Science</option>
                                    <option value="bsc-nursing">BSc Nursing</option>
                                    <option value="bpt">BPT</option>
                                    <option value="b-design">B.Design</option>
                                    <option value="llb">LLB</option>
                                    <option value="mass-communication">Mass Communication</option>
                                </select>
                            </div>

                            {/* Original Date */}
                            <div>
                                <label className="text-xs font-medium text-slate-600">
                                    Original Date & Time *
                                </label>
                                <select
                                    name="originalDateTime"
                                    value={form.originalDateTime}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 rounded-md border border-slate-300
            px-2.5 py-1.5 text-sm bg-white
            focus:outline-none focus:ring-1 focus:ring-[#e35e26]
            focus:border-[#e35e26]"
                                >
                                    <option value="">Select original date & time</option>
                                    <option value="31st Jan, 2026 - 01:00 PM To 03:00 PM">31st Jan, 2026 - 01:00 PM To 03:00 PM</option>
                                    <option value="31st Jan, 2026 - 04:00 PM To 06:00 PM">31st Jan, 2026 - 04:00 PM To 06:00 PM</option>
                                    <option value="1st Feb, 2026 - 01:00 PM To 03:00 PM">1st Feb, 2026 - 01:00 PM To 03:00 PM</option>
                                    <option value="1st Feb, 2026 - 04:00 PM To 06:00 PM">1st Feb, 2026 - 04:00 PM To 06:00 PM</option>
                                    <option value="8th Feb, 2026 - 01:00 PM To 03:00 PM">8th Feb, 2026 - 01:00 PM To 03:00 PM</option>
                                    <option value="8th Feb, 2026 - 04:00 PM To 06:00 PM">8th Feb, 2026 - 04:00 PM To 06:00 PM</option>
                                </select>
                            </div>

                            {/* Preferred Date */}
                            <div>
                                <label className="text-xs font-medium text-slate-600">
                                    Preferred New Date & Time *
                                </label>
                                <select
                                    name="preferredDateTime"
                                    value={form.preferredDateTime}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 rounded-md border border-slate-300
            px-2.5 py-1.5 text-sm bg-white
            focus:outline-none focus:ring-1 focus:ring-[#e35e26]
            focus:border-[#e35e26]"
                                >
                                    <option value="">Select preferred date & time</option>

                                    <option value="6th Feb, 2026 - 01:00 PM To 03:00 PM">6th Feb, 2026 - 01:00 PM To 03:00 PM</option>
                                    <option value="7th Feb, 2026 - 01:00 PM To 03:00 PM">7th Feb, 2026 - 01:00 PM To 03:00 PM</option>
                                    <option value="8th Feb, 2026 - 01:00 PM To 03:00 PM">8th Feb, 2026 - 01:00 PM To 03:00 PM</option>

                                </select>
                            </div>
                        </div>

                        {/* Reason */}
                        <div>
                            <label className="text-xs font-medium text-slate-600">
                                Reason for Change *
                            </label>
                            <textarea
                                name="reason"
                                value={form.reason}
                                onChange={handleChange}
                                rows={3}
                                required
                                className="w-full mt-1 rounded-md border border-slate-300
          px-2.5 py-1.5 text-sm
          focus:outline-none focus:ring-1 focus:ring-[#e35e26]
          focus:border-[#e35e26]"
                            />
                        </div>

                        {/* Submit */}
                        <div className="flex justify-end pt-2">
                            <button
                                type="submit"
                                className="bg-[#e35e26] hover:bg-[#cc5221]
          text-white text-sm font-medium
          px-5 py-2 rounded-md transition shadow-sm"
                            >
                                Submit Request
                            </button>
                        </div>
                    </form>

                    <ToastContainer />

                    {/* Success Modal */}
                    {showModal && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-10 backdrop-blur-sm">
                            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6">
                                <h3 className="text-lg font-semibold mb-2">Request Submitted</h3>
                                <p className="text-sm whitespace-pre-line text-slate-700 mb-4">{modalMessage}</p>
                                <div className="flex justify-end">
                                    <button
                                        className="bg-[#e35e26] px-4 py-2 text-white rounded-md"
                                        onClick={() => setShowModal(false)}
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Footer />
        </>
    )
}

export default RescheduleExam
